import styled from '@emotion/styled';

import { screen } from '@/components/common/breakpoints';
import { WistiaInlinePlayer } from '@/components/common/WistiaComponents/WistiaInlinePlayer';
import { WistiaVideoPlayer } from '@/components/common/WistiaComponents/WistiaVideoPlayer';
import { useMediaQuery } from '@/lib/useMediaQuery';

import type { HotspotImage, WistiaPopover } from '@/types/shared';

interface WistiaSectionProps extends WistiaPopover {
  imageThumbnail: HotspotImage;
}

export const WistiaSection = (props: WistiaSectionProps) => {
  const isDesktop = useMediaQuery(screen.mdQuery);

  return (
    <Container>
      {isDesktop ? (
        <WistiaInlinePlayer
          image={props.imageThumbnail}
          wistiaPopover={props}
        />
      ) : (
        <WistiaVideoPlayer image={props.imageThumbnail} wistiaPopover={props} />
      )}
    </Container>
  );
};

const Container = styled.div`
  margin-left: -8px;
  margin-right: -8px;

  ${screen.md} {
    margin-left: -20px;
    margin-right: -20px;
  }

  ${screen.lg} {
    margin-left: calc(var(--space-block-md) * -1);
    margin-right: calc(var(--space-block-md) * -1);
  }
`;
